// const LS_DEBUG = true;
// import cookies from 'browser-cookies';
// cookies.erase('bcs_1_2018_school_choices');


import factory from './factory';

const ls = factory(DN_YEAR);

export default ls;



// WEBPACK FOOTER //
// ./src/js/store/modules/ls/index.js